import React, { Component } from "react";
import { toast } from "react-toastify";
import * as yup from "yup";
import { ErrorMessage } from "components/shared/ErrorMessage";
import _ from "lodash";
import arrayService from "services/admin/masters/arrayService";
import Spinner from "components/shared/Spinner";
import { MSG_CREATE_RECORD, MSG_UPDATE_RECORD } from "constants/admin/masters/array";
import Breadcrumb from "components/shared/Breadcrumb";
import { handleChange, handleTouched,formFailure,getCurrentSlug,trimFields } from "utils/masterHelpers";
const serviceObj = new arrayService();
class Form extends Component {
  constructor(props) {
    super(props);
    this.handleChange=handleChange.bind(this);
    this.handleTouched=handleTouched.bind(this);
    this.formFailure=formFailure.bind(this);
    this.getCurrentSlug=getCurrentSlug.bind(this);
    this.trimFields=trimFields.bind(this); 

    this.state = {
      isEditForm: false,
      Id: 0,
      formReady: false,
      isSubmitting: false,
      errors: {},
      touched: {},
      form: {
        name: "",
        array_id: 0,
        array_customer_version_id: 0
      },
      arrays: [],
      arrayCustomers:[],
      breadcrumbs:[{ title: 'Array Customer Version Mapping List', url: '/admin/master/'+this.getCurrentSlug() },
                   { title: 'Array Customer Version Mapping' }
                  ]
    };
  }

  componentDidMount = async () => {
    const { Id } = this.props.match.params;
    await serviceObj.getAllDropdown().then((response) => {
      this.setState({
        arrays: response,
      });
    });
    await serviceObj.getAllCustomerDropdown().then((response) => {
      this.setState({
        arrayCustomers: response,
      });
    });
    if (Id > 0) {
      //repopulate the form
      this.setState({
        Id,
        isEditForm: true,
      });
      const Info = await serviceObj.getArrayCustomerVersionMappingDetail(Id);
      const form = this.state.form;
      form.name = Info.name;
      form.array_id = Info.array_id;
      form.array_customer_version_id = Info.array_customer_version_id;
      this.setState(
        {
          form,
        },
        () => {
          this.setState({
            formReady: true,
          });
        }
      ); //populate in form
    } else {
      //do any preload any api call if needed in caseof add form then make the form ready to load
      this.setState({
        formReady: true,
      });
    }
  }; 
  submitForm = async (e) => {
    e.preventDefault();
    this.trimFields(this.state.form);
    this.setState({
      isSubmitting: true,
    });
    const errors = await this.validateForm();
    if (_.isEmpty(errors)) {
      //now proceed to save user
      const form = this.state.form;
      try {
        let response;
        if (this.state.Id > 0 && this.state.isEditForm) {
          response = await serviceObj.updateArrayCustomerVersionMapping(form, this.state.Id);
        } else {
          response = await serviceObj.createArrayCustomerVersionMapping(form);
        }
        if (response) {
          toast.success(response.message || (this.state.isEditForm) ? MSG_UPDATE_RECORD : MSG_CREATE_RECORD);
          this.props.history.push("/admin/master/"+this.getCurrentSlug());
        }
      } catch (err) {
        //failure case
        this.formFailure();
        if (err) {
          const errors = this.state.errors;
          for (const [field, msg] of Object.entries(err)) {
            errors[field] = msg[0];
          }
          await this.setState({
            errors,
          });
        }
      }
    } else {
      //failure case
      this.formFailure();
    }
  }; 
  validateForm = async () => {
    const errors = {};
    const schema = yup.object().shape({
      array_id: yup.number().required().positive('please select an array.'),
      array_customer_version_id: yup.number().required().positive('please select an array customer.')
    });
    // check validity
    await schema
      .validate(this.state.form, { abortEarly: false })
      .catch(function (err) {
        err.inner.map((error) =>
          !errors[error.path] ? (errors[error.path] = error.message) : null
        );
      });

    this.setState({
      errors,
    });
    return errors; //return basicerrors
  }; 
  render() {
    const {
      isSubmitting,
      form,
      touched,
      errors,
      isEditForm,
      formReady,
      arrays,
      arrayCustomers,
      breadcrumbs
    } = this.state;
    return (
      <div className="form-wrap mt-3">
        {isSubmitting ? <Spinner /> : null}
        {formReady ? (
          <div className="form-group">
            <Breadcrumb data={breadcrumbs} isEdit={isEditForm} />
            <form onSubmit={this.submitForm}>

              <div className="form-group">
                <label htmlFor="array_id">Array</label>
                <select
                  name="array_id"
                  onChange={this.handleChange}
                  value={form.array_id}
                  className={`form-control ${
                    touched.array_id && errors.array_id
                      ? "is-invalid"
                      : ""
                    }`}
                >
                  <option key="-1" value="0">
                    --SELECT--
                  </option>
                  {arrays.length
                    ? arrays.map((array, index) => (
                      <option key={index} value={array.id}>
                        {array.name}
                      </option>
                    ))
                    : null}
                </select>
                <ErrorMessage
                  tag="div"
                  touched={touched}
                  errors={errors}
                  name="array_id"
                  className="text-danger"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="array_customer_version_id">Array Customer</label>
                <select
                  name="array_customer_version_id"
                  onChange={this.handleChange}
                  value={form.array_customer_version_id}
                  className={`form-control ${
                    touched.array_customer_version_id && errors.array_customer_version_id
                      ? "is-invalid"
                      : ""
                    }`}
                >
                  <option key="-1" value="0">
                    --SELECT--
                  </option>
                  {arrayCustomers.length
                    ? arrayCustomers.map((arrayCustomer, index) => (
                      <option key={index} value={arrayCustomer.id}>
                        {arrayCustomer.name}
                      </option>
                    ))
                    : null}
                </select>
                <ErrorMessage
                  tag="div"
                  touched={touched}
                  errors={errors}
                  name="array_customer_version_id"
                  className="text-danger"
                />
              </div>
              <button
                type="submit"
                className="btn btn-secondary btn-block"
                disabled={isSubmitting}
              >
                {isSubmitting
                  ? "Please wait..."
                  : isEditForm
                    ? "Update"
                    : "Add"}
              </button>
            </form>
          </div>
        ) : (
            <Spinner />
          )}
      </div>
    );
  }
}

export default Form;
